import { Component, EventEmitter } from '@angular/core';
import * as globals from '../globals';
import * as Materialize from 'angular2-materialize/dist/index';
import { Observable } from 'rxjs/Rx';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { AuthHttp, AuthConfig } from 'angular2-jwt';
import { MaterializeDirective, MaterializeAction } from 'angular2-materialize';

@Component({
    selector: 'model-share-modal',
    templateUrl: './sharemodel.component.html',
    styleUrls: ['./sharemodel.component.css']
  })
  export class ShareModelComponent {

    modalShareModelAction = new EventEmitter<string | MaterializeAction>();

    shareErrorMessage: string = '';
    sharefolder: string = '';
    linkchars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    sharefilename: string = '';
    shareprojectid: string = '';
    sharelink: string = '';
    shareemail: string = '';
    sharesubject: string = '';
    sharemessage: string = '';
    sharetenantid: string = '';
    errorMessage: string;
    private shareUrl = globals.APIURL + '/sharefile';
    constructor(private http: Http, public authHttp: AuthHttp) { }

    ngOnDestroy() {
      this.modalShareModelAction.emit({ action: 'modal', params: ['close'] });
    }


onShowShare(name: string, projectid: string, tenantid: string) {
    // Make the randomized share link
    this.shareErrorMessage = '';
    this.sharefolder = '';
    for (let i = 0; i < 20; i++) {
      this.sharefolder += this.linkchars.charAt(Math.floor(Math.random() * this.linkchars.length));
    }

    this.sharefilename = encodeURIComponent(name + '.hwf');
    this.shareprojectid = projectid;

    this.sharetenantid = tenantid;

    this.sharelink = globals.WEBSITEURL + '/#/shareview/?file=' +
    this.sharefolder + '/' + this.sharefilename;

    console.log('BARK BARKShare link:', this.sharelink);
    this.modalShareModelAction.emit({ action: 'modal', params: ['open'] });

  }

  onShare(event: any) {
    this.shareErrorMessage = '';
    if (!this.shareemail || !this.sharesubject || !this.sharemessage || !this.sharelink) {
      this.shareErrorMessage = 'All fields are required';
      return;
    }

    this.modalShareModelAction.emit({ action: 'modal', params: ['close'] });

    Materialize.toast('SHARE EMAIL...', 2000);

    let sharedata = {
      tenantid: this.sharetenantid, projectid: this.shareprojectid, email: this.shareemail, subject: this.sharesubject,
      message: this.sharemessage, link: this.sharelink, folder: this.sharefolder, filename: this.sharefilename
    };

    console.log('onShare shareData:', sharedata);

    // Clear out the dialog fields
    this.shareemail = '';
    this.sharesubject = '';
    this.sharemessage = '';

    this.share(sharedata)
    .subscribe(
      data => {
        this.shareErrorMessage = '';
        console.log('File share successful');
        Materialize.toast('FILE SHARED SUCCESSFULLY', 2000);
      },
      error => {
        this.shareErrorMessage = <any>error;
        console.error('onShare() error:', this.errorMessage);
        Materialize.toast('FILE SHARE FAILED - PLEASE TRY AGAIN.', 2000);
      }
    );
  }


  share(sharedata: any): Observable<string> {
    console.log('share service method called');
    // console.log('sharedata:', sharedata);

    let body = JSON.stringify(sharedata);
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ headers: headers, body: body });
    // console.log('URL =>', this.shareUrl);
    // console.log('OPTIONS =>', options);

    return this.authHttp.post(this.shareUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  private extractData(res: Response) {
    let body = res.json();
    // console.log('BODY:', body);
    return body || {};
  }

  handleError(error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    let errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    console.error('CAUGHT AN ERROR:', errMsg); // log to console instead
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/sharemodel/sharemodel.component.ts